/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function() {

    $(".quantity_options span input").val("");
    $(".product_item p input").prop("checked", false);

    window.addEventListener("pageshow", function(event) {
        var historyTraversal =
            event.persisted ||
            (typeof window.performance != "undefined" &&
                window.performance.navigation.type === 2);
        if (historyTraversal) {
            // Handle page restore.
            window.location.reload();
        }
    });

    $(document).on("click", ".steps_button .next_step", function() {
        $(".first_steps").hide();
        $(".second_steps").fadeIn();
        $("html,body").animate({
                scrollTop: $("body").offset().top,
            },
            "slow"
        );
        $("span.prev_step").removeClass("hide_btn");
        $('.steps_button .next_step').addClass("hide_btn");
    });
    $(document).on("click", ".steps_button .prev_step", function() {
        $(".product_item p input").prop("checked", false);
        $(".second_steps").hide();
        $(".first_steps").fadeIn();
        $("html,body").animate({
                scrollTop: $("body").offset().top,
            },
            "slow"
        );
        $(".next_step").removeClass("hide_btn");
        $(".next_step").addClass("disabled");
        $('.steps_button .prev_step').addClass("hide_btn");
        $(".second_steps_item").removeClass("show_product");
        $(".second_steps_item").find(".quantity_options span input").val("");
    });

    // next step product show
    $(document).on(
        "click",
        ".first_steps.active input[type=checkbox]",
        function() {
            $("span.next_step").removeClass("disabled");
            var GetId = $(this).attr("value");
            $(".product_item.second_steps .second_steps_item").each(function() {
                var matchId = $(this).data("id");
                if (GetId == matchId) {
                    $(this).toggleClass("show_product");
                }
            });
        }
    );

    //set variant id

    $(".second_steps .second_steps_item").each(function() {
        var colorValue = $(this)
            .find(".product_details .color_selector")
            .find(".select__select option:selected")
            .val();
        // alert(colorValue);
        $(this)
            .closest(".second_steps_item")
            .find('.custom_product_select p[data-name="available"]')
            .each(function() {
                var Qty = $(this).attr("data-qty");
                var variantId = $(this).attr("data-value");
                var availableItem = $(this).attr("data-title");
                //console.log(variantId);
                var SizeValue = $(this).attr("data-item");
                var merge = colorValue + "-" + SizeValue;
                if (availableItem == merge) {
                    $(this)
                        .closest(".second_steps_item")
                        .find('.quantity_options span[data-size="' + SizeValue + '"] input')
                        .attr("data-id", variantId);
                    $(this)
                        .closest(".second_steps_item")
                        .find('.quantity_options span[data-size="' + SizeValue + '"] input')
                        .attr("max", Qty);
                    $(this)
                        .closest(".second_steps_item")
                        .find(
                            '.quantity_options span[data-size="' + SizeValue + '"] .qty_value'
                        )
                        .text(Qty);
                }
            });
    });

    // soldout disabled

    $(document).on("change", ".color_selector .select__select", function() {
        var colorValue = $(this).find("option:selected").val();
        //console.log(colorValue);
        $(this)
            .closest(".second_steps_item")
            .find(".size_option span.size_label")
            .removeClass("disabled");
        $(this)
            .closest(".second_steps_item")
            .find(".quantity_options span.mobile_size")
            .removeClass("disabled");
        $(this)
            .closest(".second_steps_item")
            .find(".quantity_options span input")
            .removeAttr("disabled");
        $(this)
            .closest(".second_steps_item")
            .find(".quantity_options span input")
            .val("");
        $(this)
            .closest(".second_steps_item")
            .find('.custom_product_select p[data-name="soldout"]')
            .each(function() {
                var soldItem = $(this).attr("data-title");
                var soldSize = $(this).attr("data-item");
                var merge = colorValue + "-" + soldSize;
                // console.log(soldSize);
                // console.log(merge);
                if (soldItem == merge) {
                    $(this)
                        .closest(".second_steps_item")
                        .find('.size_option span[data-value="' + soldSize + '"]')
                        .addClass("disabled");
                    $(this)
                        .closest(".second_steps_item")
                        .find(
                            '.quantity_options span[data-size="' +
                            soldSize +
                            '"] span.mobile_size'
                        )
                        .addClass("disabled");
                    $(this)
                        .closest(".second_steps_item")
                        .find('.quantity_options span[data-size="' + soldSize + '"] input')
                        .prop("disabled", true);
                    $(this)
                        .closest(".second_steps_item")
                        .find('.quantity_options span[data-size="' + soldSize + '"] input')
                        .val("");
                    $(this)
                        .closest(".second_steps_item")
                        .find(
                            '.quantity_options span[data-size="' + soldSize + '"] .qty_value'
                        )
                        .text("");
                }
            });

        // available var id set
        $(this)
            .closest(".second_steps_item")
            .find('.custom_product_select p[data-name="available"]')
            .each(function() {
                var Qty = $(this).attr("data-qty");
                var variantId = $(this).attr("data-value");
                var availableItem = $(this).attr("data-title");
                //console.log(variantId);
                var SizeValue = $(this).attr("data-item");
                var merge = colorValue + "-" + SizeValue;
                if (availableItem == merge) {
                    $(this)
                        .closest(".second_steps_item")
                        .find('.quantity_options span[data-size="' + SizeValue + '"] input')
                        .attr("data-id", variantId);
                    $(this)
                        .closest(".second_steps_item")
                        .find('.quantity_options span[data-size="' + SizeValue + '"] input')
                        .attr("max", Qty);
                    $(this)
                        .closest(".second_steps_item")
                        .find(
                            '.quantity_options span[data-size="' + SizeValue + '"] .qty_value'
                        )
                        .text(Qty);
                }
            });
    });

    $(".quantity_options span input").keyup(function() {
        var max = parseInt($(this).attr("max"));
        var min = parseInt($(this).attr("min"));
        var value = $(this).val();
        if ($(this).val() > max) {
            $(this).val(max);
        } else if ($(this).val() < min) {
            $(this).val(min);
        }
    });

    // checkbox checked value set

    $(".itg_checkbox").change(function() {
        var tmp_arr = "";
        var dataindex = $(this).closest(".show_product").attr("data-index");
        var len = $(".logo_location_" + dataindex).find(
            "input[type='checkbox']:checked"
        ).length;
        $(this)
            .closest(".logo_location_" + dataindex)
            .attr("data-qty", len);
        $(".logo_location_" + dataindex)
            .find("input[type='checkbox']")
            .each(function() {
                if (this.checked) {
                    var checked_val = $(this).val();
                    tmp_arr += checked_val + ",";
                }
            });
        var tmp_arr = tmp_arr.replace(/,*$/, "");
        $(this)
            .closest(".logo_location_" + dataindex)
            .find(".line-item-property__field input")
            .val(tmp_arr);
    });

    // Main add to Cart

    $(document).on(
        "change",
        ".second_steps_item.show_product span.var_input input",
        function() {
            var dataindex = $(this).closest(".show_product").attr("data-index");
            //alert(dataindex);
            var total = 0;
            $(".itg_options_" + dataindex)
                .find(".quantity_options .quntity_inputs .var_input input")
                .each(function() {
                    if ($(this).val() !== "") {
                        //   alert(total);
                        total += parseInt($(this).val());
                    }
                });
            $(this)
                .closest(".second_steps_item.show_product")
                .find(".logo_location_" + dataindex)
                .attr("input-qty", total);
        }
    );

    // Main add to cart
    $(document).on("click", ".main_add_cart_button button", function() {

        var available_ids = [];
        var propertydata = [];
        var extraproduct = [];

        $(".second_steps_item.show_product span.var_input input").each(function() {
            var Quntity = $(this).val();
            var varId = $(this).attr("data-id");
            var randomId = $(this).attr("data-random");

            var logoColorNumber = $(this).closest(".second_steps_item.show_product").find(".number_of_color_logo .select_options select option:selected").val();
            var logolocation = $(this).closest(".second_steps_item.show_product").find(".logo_location .logo_location_name p input#Location").val();

            if (Quntity != "" && logoColorNumber != "" && logolocation != "") {
                $(".main_add_cart_button .text").hide();
                $(".main_add_cart_button span.loader").fadeIn();
                var toPushItem = varId + "-" + Quntity + "-" + randomId + "-" + logoColorNumber + "-" + logolocation;
                available_ids.push(toPushItem);
            }
        });

        $(".second_steps_item.show_product .select_options select").each(function() {
            var dataindex = $(this).closest(".show_product").attr("data-index");

            var extraProductID = $(".itg_options_" + dataindex)
                .find(".select_options select option:selected")
                .attr("data-value");
            var randomId = $(".itg_options_" + dataindex)
                .find(".select_options select option:selected")
                .attr("data-random");
            var extraProductQty = $(".itg_options_" + dataindex)
                .find(".logo_location")
                .attr("data-qty");
            var extrainputQty = $(".itg_options_" + dataindex)
                .find(".logo_location")
                .attr("input-qty");

            var totalQty = extraProductQty * extrainputQty;
            //console.log(totalQty);
            if (extraProductID != "undefined" && totalQty != "undefined") {
                var extraContent = extraProductID + "-" + totalQty + "-" + randomId;
                console.log(extraContent);
                extraproduct.push(extraContent);
            }
        });

        // return false;

        var logo_file = $('#send_file').val();
        var logo_description = $('#logo_description').val();

        for (var i = 0; i < available_ids.length; i++) {
            (function(i) {
                setTimeout(function() {
                    var formContents = available_ids[i].split("-");
                    var var_Id = formContents[0];
                    var var_qty = formContents[1];
                    var random_number = formContents[2];
                    var number_of_color = formContents[3];
                    var number_of_location = formContents[4];
                    if (
                        number_of_color == "undefined" &&
                        number_of_location == "undefined"
                    ) {
                        var main_data = {
                            id: var_Id,
                            quantity: var_qty,
                            properties: {
                                Logo: logo_file,
                                Logo_Description: logo_description,
                                Id: random_number,
                            },
                        };
                    } else {
                        var main_data = {
                            id: var_Id,
                            quantity: var_qty,
                            properties: {
                                "Number Of Colors Of Logo": number_of_color,
                                Location: number_of_location,
                                Logo: logo_file,
                                Logo_Description: logo_description,
                                Id: random_number,
                            },
                        };
                    }

                    var params = {
                        type: "POST",
                        url: "/cart/add.js",
                        data: main_data,
                        dataType: "json",
                        success: function(line_item) {
                            var iteration_length = i + 1;
                            if (iteration_length == available_ids.length) {
                                // document.location.href = '/cart';
                                // return false;
                                // extra product add
                                for (var j = 0; j < extraproduct.length; j++) {
                                    (function(j) {
                                        setTimeout(function() {
                                            var extrasection = extraproduct[j].split("-");
                                            //console.log(extrasection);

                                            var varId = extrasection[0];
                                            var varqty = extrasection[1];
                                            var randomnumber = extrasection[2];

                                            if (varId != "undefined" && varqty != "undefined") {
                                                var main_data_one = {
                                                    id: varId,
                                                    quantity: varqty,
                                                    properties: {
                                                        Logo: logo_file,
                                                        Logo_Description: logo_description,
                                                        Id: randomnumber,
                                                    },
                                                };
                                            }
                                            var params_one = {
                                                type: "POST",
                                                url: "/cart/add.js",
                                                data: main_data_one,
                                                dataType: "json",
                                                success: function(line_item) {
                                                    var iteration_length = j + 1;
                                                    if (iteration_length == extraproduct.length) {
                                                        document.location.href = "/cart";
                                                    }
                                                },
                                                error: function() {
                                                    console.log("extra fail");
                                                },
                                            };
                                            $.ajax(params_one);
                                        }, 1000 * j);
                                    })(j);
                                }
                            }
                        },
                        error: function() {
                            console.log("fail");
                        },
                    };
                    $.ajax(params);
                }, 1000 * i);
            })(i);
        }

    });

    $(document).on("click", ".custom_cartremove", function() {
        var randomNumber = $(this).attr("data-random");
        var data = {
            updates: {}
        };
        $(".line-item-table .line-item").each(function() {
            var gridrandom = $(this).attr("data-randomgrid");
            if (randomNumber == gridrandom) {
                var variantid = $(this).attr("data-variantid");
                var qty = 0;
                data.updates[variantid] = qty;
            }
        });
        jQuery.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: data,
            dataType: "json",
            success: function(data) {
                document.location.href = "/cart";
            },
        });
    });

    $(document).on('change', '#upload_image', function() {
        if ($(this).val() != '') {
            $('#send_file').val('');
            var form_data = new FormData();
            var file_data = $('#upload_image').prop("files")[0];
            form_data.append("image", file_data);
            $.ajax({
                type: 'POST',
                url: 'https://dev.shopifyexperthelp.com/app/spotted-whale/metroswimshop.php',
                data: form_data,
                contentType: false,
                cache: false,
                processData: false,
                success: function(response) {
                    $('#send_file').val(response);
                    $('#multiple_addtocart').removeAttr('disabled');
                }
            });
        }
    });


});
